module.exports = __webpack_public_path__ + "img/bg2.7e0dce6d.jpg";